import React from 'react';
import * as S from './styled';
export const Pills = ({ children }) => {
    return React.createElement(S.Container, null, children);
};
export const Pill = ({ active, label, onClick }) => (React.createElement(S.PillItem, { active: active, onClick: onClick }, label));
Pills.Pill = Pill;
